<template>
  <div>
    <el-row class="tree-content" :gutter="20">
      <el-col :span="24">
        <div class="filter-inline-panel cle">
          <el-form :inline="true" size="mini" :model="filters" class="filter-panel"></el-form>
          <div class="list-opinion fr">
	        <el-button type="primary" size="mini" @click="$router.back(-1)">{{$t('index.return')}}</el-button>
            <el-button type="primary" size="mini" @click="add()"  v-if="hasBtn('sub_add')">{{$t('index.add')}}</el-button>
          </div>
        </div>
      </el-col>
    </el-row>
    <el-row class="tree-content" type="flex" :gutter="20">
      <el-col :span="24">
        <el-table :data="list" border size="mini">
          <el-table-column :prop="lang=='cn'?'name_cn':'name'" align="center" :label="$t('dictionary.name')"></el-table-column>
          <el-table-column prop="code" align="center" :label="$t('dictionary.value')"></el-table-column>
          <el-table-column prop="sort" align="center" :label="$t('index.sort')"></el-table-column>
          <el-table-column :label="$t('index.operation')" align="center">
            <template slot-scope="scope">
              <el-button size="mini" type="primary" v-if="hasBtn('sub_edit')" @click="add(scope.row)">{{$t('index.edit')}}</el-button>
              <el-button size="mini" type="danger" v-if="hasBtn('sub_del')" @click="del(scope.row)">{{$t('index.del')}}</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
    </el-row>
    <el-dialog :title="$t('index.dialog_title')" width="700px" :close-on-click-modal="false" :visible="editFormVisible" @close="editFormVisible = false">
      <el-row class="tree-content" :gutter="20">
        <el-form :model="editForm" size="mini" label-width="55px" label-position="top" :rules="editFormRules" ref="editForm">
          <el-col :span="12">
            <el-form-item :label="$t('index.cn')+$t('dictionary.name')" prop="name_cn">
              <el-input v-model="editForm.name_cn" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('index.en')+$t('dictionary.name')" prop="name">
              <el-input v-model="editForm.name" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('dictionary.value')" prop="code">
              <el-input v-model="editForm.code" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('index.sort')" prop="sort">
              <el-input v-model="editForm.sort" class="w100" :placeholder="$t('index.pleaseInput')" auto-complete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-form>
      </el-row>
      <div slot="footer" class="dialog-footer">
        <el-button size="mini" @click.native="editFormVisible = false">{{$t('index.cancel')}}</el-button>
        <el-button size="mini" type="primary" @click.native="editSubmit('editForm')">{{$t('index.submit')}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
export default {
	name:'no_cache',
	computed: {
		editFormRules(){
			return{
				name_cn: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.cn')+this.$t('dictionary.name'),
					trigger: 'blur'
				}],
				name: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('index.en')+this.$t('dictionary.name'),
					trigger: 'blur'
				}],
				code: [{
					required: true,
					message: this.$t('index.pleaseInput')+this.$t('dictionary.list_code'),
					trigger: 'blur'
				}],
			}
		},
	},
	data() {
		return {
			id:'',
			list: [],
			editFormVisible: false,
			editForm: {
				name:'',
				name_cn:'',
				code: '',
				sort: '',
			},
			filters: {},
		}
	},
	// 初始事件
	mounted: function () {
		this.id=this.$route.query.id;
		this.init();
	},
	// 事件
	methods: {
		// 初始化
		init() {
			var this_ = this;
			var url = "dictionaryListList";
			var datas = {
				dictionary_id:this_.id,
			};
			this_.$post(url, datas).then((res) => {
				this_.list = res;
			})
		},
		add(data) {
			if (data) {
				this.editForm = JSON.parse(JSON.stringify(data));
			} else {
				this.editForm = {
					name:'',
					name_cn:'',
					code: '',
					sort: '',
				}
			}
			if (this.$refs.editForm) {
				this.$refs.editForm.resetFields();
			}
			this.editFormVisible = true;
		},
		// 保存
		editSubmit(editForm) {
			var this_ = this;
			this_.$refs.editForm.validate((valid) => {
				if (valid) {
					var datas = {
						name_cn: this_.editForm.name_cn,
						name: this_.editForm.name,
						code: this_.editForm.code,
						sort: this_.editForm.sort,
						dictionary_id: this_.id,
					}
					var url = "addDictionaryList";
					var tishi = this_.$t('index.add_success');
					if (this_.editForm.id) {
						datas['id'] = this_.editForm.id;
						tishi = this_.$t('index.modify_success');
						url = "editDictionaryList";
					}
					this_.$post(url, datas).then((res) => {
						this_.$message.success(tishi);
						this_.editFormVisible = false;
						this_.init();
					});
				} else {
					return false;
				}
			})
		},
		// 删除
		del(data) {
			var this_ = this;
			var url = "deleteDictionaryList";
			var datas = {
				id: data.id
			};
			this_.$confirm(this_.$t('index.confirm_delete'), this_.$t('index.tips')).then(() => {
				this_.$post(url, datas).then((res) => {
					this_.$message.success(this_.$t('index.delete_success'));
					this_.init();
				})
			}).catch(() => {});
		},
	},
	// 过滤器
	filters: {

	}
}
</script>
<style scoped>
.filter-inline-panel {
	margin-bottom: 22px;
}
.page-pagination {
	padding: 20px 10px;
}
</style>



// WEBPACK FOOTER //
// src/views/system/data_dictionary_list.vue